const NONCE_EXPIRATION_TIME = 3600000;

const noCacheHeaders: HeadersInit = {
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  Pragma: 'no-cache',
  Expires: '0',
};

export function getNoCacheHeaders(): HeadersInit {
  return noCacheHeaders;
}

export function invalidateNonceCache(type: 'models' | 'global'): void {
  try {
    localStorage.removeItem('rnm_nonce_' + type);
    localStorage.removeItem('rnm_nonce_' + type + '_timestamp');
    console.log('🗑️ Cache de nonce invalidado para ' + type);
  } catch (e) {
    console.warn('Error invalidando cache de nonce:', e);
  }
}

function fetchFreshNonce(type: 'models' | 'global'): Promise<string> {
  const url =
    ajaxUrl() + '?action=rnm_get_nonce&type=' + encodeURIComponent(type);

  return fetch(url, {
    method: 'GET',
    credentials: 'same-origin',
    headers: noCacheHeaders,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Error al obtener nonce: ' + response.status);
      }
      return response.json() as Promise<{
        success: boolean;
        data?: { nonce?: string };
      }>;
    })
    .then((nonceResponse) => {
      if (!nonceResponse.success || !nonceResponse.data?.nonce) {
        throw new Error('Nonce no válido recibido');
      }
      const freshNonce = nonceResponse.data.nonce;
      try {
        localStorage.setItem('rnm_nonce_' + type, freshNonce);
        localStorage.setItem(
          'rnm_nonce_' + type + '_timestamp',
          Date.now().toString()
        );
        console.log('✓ Nonce fresco almacenado en cache para ' + type);
      } catch (e) {
        console.warn('No se pudo almacenar nonce en localStorage:', e);
      }
      return freshNonce;
    });
}

function ajaxUrl(): string {
  const u = window.rnmAjax?.ajaxurl;
  if (!u) {
    throw new Error('rnmAjax.ajaxurl no está definido');
  }
  return u;
}

export function getValidNonce(type: 'models' | 'global'): Promise<string> {
  const storageKey = 'rnm_nonce_' + type;
  const timestampKey = 'rnm_nonce_' + type + '_timestamp';

  try {
    const cachedNonce = localStorage.getItem(storageKey);
    const cachedTimestamp = localStorage.getItem(timestampKey);

    if (cachedNonce && cachedTimestamp) {
      const now = Date.now();
      const elapsed = now - parseInt(cachedTimestamp, 10);
      if (elapsed < NONCE_EXPIRATION_TIME) {
        console.log(
          '✓ Usando nonce cacheado para ' +
            type +
            ' (válido por ' +
            Math.round((NONCE_EXPIRATION_TIME - elapsed) / 60000) +
            ' min más)'
        );
        return Promise.resolve(cachedNonce);
      }
      console.log('⌛ Nonce expirado para ' + type + ', solicitando uno nuevo...');
    } else {
      console.log('🆕 No hay nonce cacheado para ' + type + ', solicitando uno nuevo...');
    }
  } catch (e) {
    console.warn('Error accediendo a localStorage:', e);
  }

  return fetchFreshNonce(type);
}
